import { useState, useCallback } from 'react';

export default function useCommonAlert() {
  const [isSwalCommon, setIsSwalCommon] = useState({
    row: null,
    show: false,
    title: null,
    type: null,
    message: null,
    onConfirm: null,
    onCancel: null,
    confirmBtnText:null,
    cancelBtnText:null,
    showCancel:false,
    showConfirm:false,
    cancelBtnCls:null,
    isConfirmLoading: false,
  });

  const showCustomeSwal = useCallback(({ row = null,show=true,title, type, message, onConfirm,onCancel,confirmBtnText,cancelBtnText,showCancel,showConfirm ,cancelBtnCls}) => {
    setIsSwalCommon({
        row,
        show,
        title,
        type,
        message,
        onConfirm,
        onCancel,
        confirmBtnText,
        cancelBtnText,
        showCancel,
        showConfirm,
        cancelBtnCls,
        isConfirmLoading: false,
    });
  }, []);

  const setConfirmLoading = useCallback((loading) => {
    setIsSwalCommon((prev) => ({ ...prev, isConfirmLoading: loading }));
  }, []);

  const hideCustomeSwal = useCallback(() => {
    setIsSwalCommon({
        row: null,
        show: false,
        title: null,
        type: null,
        message: null,
        onConfirm: null,
        onCancel: null,
        confirmBtnText:null,
        cancelBtnText:null,
        showCancel:false,
        showConfirm:false,
        isConfirmLoading: false,
    });
  }, []);

  return { isSwalCommon, setIsSwalCommon, showCustomeSwal, hideCustomeSwal, setConfirmLoading };
}
